/**
 * User ID for anonymous customer.
 */
export var NOT_AUTHENTICATED_CUSTOMER_ID = -1;
//# sourceMappingURL=customer.js.map